"use client"

/* eslint-disable react/no-unescaped-entities */
import { useMiniCartStore } from "@/components/MiniCart/use-new-minicart-store"
import Price from "@/components/Price"
import { Maybe, Money } from "@/types/graphql.prod"
import { LinkButton } from "../../ui/link-button"
import Link from "next/link"
export function MiniCartFooter({
  grandTotal,
}: {
  grandTotal: Maybe<Money> | undefined
}) {
  const setOpen = useMiniCartStore((state) => state?.setDialogOpen)

  return (
    <div
      style={{
        boxShadow: "0px 0px 15px 0px #00000040",
      }}
      className="flex w-full flex-col px-[24px] pb-[12px] pt-[10px] lg_pb-[18px] lg_pt-[20px]"
    >
      <div className="flex items-center justify-between">
        <p className="font-poppins text-sm font-[600] leading-[28px] text-title">
          Order Total:
        </p>
        <div className="font-poppins text-[20px] font-[600] text-title">
          <Price
            value={grandTotal?.value ?? 0}
            currencyCode={grandTotal?.currency}
          />
        </div>
      </div>

      <div className="flex items-center justify-between">
        <p className="font-poppins text-sm font-[600] leading-[28px] text-title">
          Shipping:
        </p>
        <div className="font-poppins font-[600] text-title">FREE</div>
      </div>

      <div className="mt-[10px] flex flex-col items-center gap-[10px] lg_gap-[15px]">
        <LinkButton
          href="/checkout"
          className="h-[40px] w-full rounded-[10px] bg-primary font-poppins font-[600] text-white lg_h-[54px]"
          onClick={() => setOpen(false)}
        >
          CHECKOUT
        </LinkButton>
        <Link
          href="/cart"
          className="font-sans text-sm font-[600] leading-[1.2] text-primary underline"
          onClick={() => setOpen(false)}
        >
          View cart
        </Link>
      </div>
    </div>
  )
}
